import { parse } from "cookie";
import CircularProgress from "node_modules/@mui/material/esm/CircularProgress/CircularProgress";
import { useEffect, useState } from "react";
import { LoaderFunction, MetaFunction, useLoaderData } from "react-router";
import BreadCrubComponent from "~/components/shared-components/BreadCrubComponent";
import IframeWithLoader from "~/components/shared-components/IframeWithLoader";
import { getPageMeta } from "~/lib/helperFuncation/metaHelper";
import { setIsDialogClose, setIsDialogOpen } from "~/lib/store/slice/loginSlice";
import { getBhaktiToken } from "~/lib/store/slice/profileSlice";
import { useAppDispatch } from "~/lib/store/store";
import { AUTH_COOKIE_TOKEN, FALLBACK_IMAGE_URL, ICON_ORANGE_COLOR } from "~/utils/constant";
import { homeRouteString } from "~/utils/helper-funcations";
import { metaService } from "~/utils/metaService";

export const meta: MetaFunction = ({ location, params }) => {
  const pathname = location?.pathname || "/";
  const lang = params.lang || "en";

  const meta = getPageMeta("registration", lang);

  return metaService({
    title: meta.metaTitle,
    description: meta.metaDescription,
    ogTitle: meta.ogTitle,
    ogDescription: meta.ogDescription,
    ogUrl: pathname,
    ogImg: meta.ogImage || FALLBACK_IMAGE_URL,
    ogWidth: meta.ogImageWidth || "1200",
    ogHeight: meta.ogImageHeight || "630",
    canonicalLink: pathname,
    hreflangs: [
      { hrefLang: "x-default", href: `${pathname}` },
      { hrefLang: "en", href: `${pathname}` },
      { hrefLang: "gu", href: `${pathname}` },
    ],
  });
};

export const loader: LoaderFunction = async ({ params, request }) => {
  const lang = params.lang;
  const paramToken = params.token; // Get token from URL params first

  const cookieHeader = request.headers.get("Cookie") || "";
  const cookies = parse(cookieHeader);

  // const token = paramToken || cookies[AUTH_COOKIE_TOKEN] || null;

  const authToken = cookies[AUTH_COOKIE_TOKEN] || null;
  const token = paramToken || null;

  // if (!token || !contentToken) {
  //   return redirect(`/${lang}`);
  // }

  // const apiService = new SmkApiService(token ?? "");
  // const familyData = token ? await apiService.getFamilyMember() : null;

  return {
    title: lang === "gu" ? " નોંધણી" : "Registration",
    token,
    authToken,
  };
};

export const handle = {
  breadcrumb: (match: any) => {
    const lang = match.params.lang;
    return (
      <BreadCrubComponent
        breadCrub={[
          {
            path: homeRouteString(lang).path,
            title: homeRouteString(lang).home,
          },
        ]}
      />
    );
  },
};

function Registration() {
  const { token, authToken } = useLoaderData<{ token: string; authToken: string }>();
  const dispatch = useAppDispatch();
  const [bhaktiToken, setBhaktiToken] = useState<string | null>(null);

  useEffect(() => {
    if (!authToken) {
      dispatch(setIsDialogOpen());
    } else {
      (async () => {
        const res = await dispatch(getBhaktiToken()).unwrap();
        if (!res.bhaktiToken) return;
        setBhaktiToken(res.bhaktiToken);
      })();
      dispatch(setIsDialogClose());
    }
  }, [authToken, dispatch]);

  if (!authToken) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <CircularProgress size={60} style={{ color: ICON_ORANGE_COLOR }} />
      </div>
    );
  }

  const iframeUrl = `https://cms.swaminarayanbhagwan.org:36898/?render_token=${bhaktiToken}&deptid=2` + (token ? `&formid=${token}` : "");
  return <IframeWithLoader src={iframeUrl} title="Registration" loadingText="Loading Registration Form..." allow="payment" />;
}

export default Registration;
